export default __webpack_public_path__ + "static/media/Licenses icon color 0285A1.7bc1b203.svg";